import axios from "axios";
import { API_URL } from "../../config";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "XCSRF-TOKEN";

const Api = axios.create({ baseURL: API_URL });

export const getObjects = async (endpoint, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const response = await Api.get(`/${endpoint}`, { headers });
  return response.data;
};

export const getObject = async (endPoint, id, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const response = await Api.get(`/${endPoint}/${id}`, { headers });
  return response.data;
};

export const addObject = async (
  endpoint,
  modelObject,
  token = "",
  isMultipart = false,
) => {
  const headers = {};

  if (token) {
    headers.Authorization = `Token ${token}`;
  }

  if (!isMultipart) {
    headers["Content-Type"] = "application/json";
  }

  return await Api.post(`/${endpoint}/`, modelObject, { headers });
};

export const updateObject = async (
  endPoint,
  modelObject,
  rowId,
  token = "",
) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  return await Api.patch(`/${endPoint}/${rowId}/`, modelObject, { headers });
};

export const deleteObject = async (endPoint, id, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  return await Api.delete(`/${endPoint}/${id}/`, { headers });
};
